import React, { useEffect, useState, useCallback } from 'react';
import Sidebar from '../components/layout/Sidebar';
import { AUTH_STORAGE_KEY } from '../socket';
import MobileBottomNav from '../components/layout/MobileBottomNav';

const getToken = () => { try { return JSON.parse(localStorage.getItem(AUTH_STORAGE_KEY))?.token || null; } catch { return null; } };
const authHeader = () => { const t = getToken(); return t ? { Authorization: 'Bearer ' + t } : {}; };

export default function SeoCategoryMasterPage() {
  const [role, setRole] = useState(3);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({ name: '', keywords: '' });
  const [saving, setSaving] = useState(false);
  const [deleting, setDeleting] = useState(null);
  const [editId, setEditId] = useState(null);
  const [editForm, setEditForm] = useState({ name: '', keywords: '' });
  const [uploading, setUploading] = useState(false);
  const [toast, setToast] = useState(null);
  const [isMobile, setIsMobile] = useState(false);
  const [activeTab, setActiveTab] = useState("Overview");

  const showToast = (msg, type = 'success') => {
    setToast({ msg, type });
    setTimeout(() => setToast(null), 3000);
  };
useEffect(() => {
    try {
      const raw = localStorage.getItem(AUTH_STORAGE_KEY);
      const parsed = raw ? JSON.parse(raw) : null;
      const user = parsed?.user || {};
      setRole(Number(user.role) || (user.isAdmin ? 2 : 3));
    } catch (err) {
      setRole(3);
    }
  }, []);

   useEffect(() => {
      const handleResize = () => {
        setIsMobile(window.innerWidth <= 640);
      };
      handleResize();
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, []);
  const fetchCategories = useCallback(async () => {
    setLoading(true);
    try {
      const res = await fetch('/api/seo-categories', { headers: authHeader() });
      const data = await res.json();
      setCategories(Array.isArray(data.categories) ? data.categories : []);
    } catch { setCategories([]); }
    setLoading(false);
  }, []);

  useEffect(() => { fetchCategories(); }, [fetchCategories]);

  useEffect(() => {
    try {
      const raw = localStorage.getItem(AUTH_STORAGE_KEY);
      const parsed = raw ? JSON.parse(raw) : null;
      const user = parsed?.user || {};
      setRole(Number(user.role) || (user.isAdmin ? 2 : 3));
    } catch { setRole(3); }
  }, []);

  const handleAdd = async (e) => {
    e.preventDefault();
    if (!form.name.trim()) return;
    setSaving(true);
    try {
      const res = await fetch('/api/seo-categories', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...authHeader() },
        body: JSON.stringify(form),
      });
      const data = await res.json();
      if (data.success) {
        showToast('SEO category added.');
        setForm({ name: '', keywords: '' });
        await fetchCategories();
      } else {
        showToast(data.error || 'Failed to add.', 'error');
      }
    } catch { showToast('Failed to add.', 'error'); }
    setSaving(false);
  };

  const handleEdit = async (id) => {
    if (!editForm.name.trim()) return;
    try {
      const res = await fetch(`/api/seo-categories/${id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...authHeader() },
        body: JSON.stringify(editForm),
      });
      const data = await res.json();
      if (data.success) {
        showToast('Updated.');
        setEditId(null);
        await fetchCategories();
      } else {
        showToast(data.error || 'Update failed.', 'error');
      }
    } catch { showToast('Update failed.', 'error'); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this SEO category?')) return;
    setDeleting(id);
    try {
      const res = await fetch(`/api/seo-categories/${id}`, { method: 'DELETE', headers: authHeader() });
      const data = await res.json();
      if (data.success) { showToast('Deleted.'); await fetchCategories(); }
      else showToast(data.error || 'Delete failed.', 'error');
    } catch { showToast('Delete failed.', 'error'); }
    setDeleting(null);
  };

  const handleDownloadTemplate = async () => {
    try {
      const res = await fetch('/api/seo-categories/download/template', { headers: authHeader() });
      if (!res.ok) { showToast('Failed to download template.', 'error'); return; }
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'SeoCategories_Template.xlsx';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
      showToast('Template downloaded.');
    } catch { showToast('Failed to download template.', 'error'); }
  };

  const handleUploadFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    try {
      const formData = new FormData();
      formData.append('file', file);
      const res = await fetch('/api/seo-categories/upload/bulk', {
        method: 'POST',
        headers: authHeader(),
        body: formData,
      });
      const data = await res.json();
      if (res.ok && data.success) {
        showToast(`✓ Imported ${data.created} categories${data.duplicates > 0 ? `, ${data.duplicates} duplicates skipped` : ''}`);
        await fetchCategories();
      } else {
        showToast(data.error || data.message || 'Upload failed.', 'error');
      }
    } catch { showToast('Upload failed.', 'error'); }
    finally { setUploading(false); e.target.value = ''; }
  };

  return (
    <div style={{ display: 'flex', height: '100vh', overflow: 'hidden' }}>
       {!isMobile && <Sidebar role={role} />}
       <div
  style={{
    flex: 1,
    height: '100vh',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column'
  }}
>
<div
  style={{
    position: 'sticky',
    top: 0,
    zIndex: 100,
    padding: '10px',
    borderBottom: '1px solid #e2e8f0'
  }}
>
        <h2 style={{ marginTop: 0, fontSize: 22, fontWeight: 700 }}>SEO Category Master</h2>

        {toast && (
          <div style={{
            padding: '10px 16px', borderRadius: 8, marginBottom: 16, fontSize: 14, fontWeight: 500,
            background: toast.type === 'success' ? '#ecfeff' : '#fef2f2',
            color: toast.type === 'success' ? '#0e7490' : '#dc2626',
            border: `1px solid ${toast.type === 'success' ? '#a5f3fc' : '#fecaca'}`
          }}>
            {toast.msg}
          </div>
        )}

        {/* Top bar: form + excel buttons */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', marginBottom: 24, flexWrap: 'wrap', gap: 12 }}>

          {/* Add form */}
         <form
  onSubmit={handleAdd}
  style={{
    display: 'flex',
    gap: 12,
    alignItems: 'flex-end',
    flexWrap: 'nowrap'
  }}
>
  <div>
    <label
      style={{
        display: 'block',
        fontSize: 12,
        fontWeight: 600,
        color: '#475569',
        marginBottom: 4
      }}
    >
      SEO Category Name <span style={{ color: '#ef4444' }}>*</span>
    </label>

    <input
      value={form.name}
      onChange={e => setForm(p => ({ ...p, name: e.target.value }))}
      placeholder="e.g. Plumbing Services"
      style={{
        width: 250,
        padding: '8px 12px',
        borderRadius: 6,
        border: '1px solid #cbd5e1',
        fontSize: 14
      }}
    />
  </div>

  <div>
    <label
      style={{
        display: 'block',
        fontSize: 12,
        fontWeight: 600,
        color: '#475569',
        marginBottom: 4
      }}
    >
      Keywords
    </label>

    <input
      value={form.keywords}
      onChange={e => setForm(p => ({ ...p, keywords: e.target.value }))}
      placeholder="e.g. plumber, pipe repair, leak fix"
      style={{
        width: 350,
        padding: '8px 12px',
        borderRadius: 6,
        border: '1px solid #cbd5e1',
        fontSize: 14
      }}
    />
  </div>

  <button
    type="submit"
    disabled={saving}
    style={{
      padding: '8px 20px',
      borderRadius: 6,
      backgroundColor: '#0ea5e9',
      color: '#fff',
      border: 'none',
      cursor: saving ? 'not-allowed' : 'pointer',
      fontWeight: 600,
      fontSize: 14,
      height: 38,
      whiteSpace: 'nowrap'
    }}
  >
    {saving ? 'Adding…' : '+ Add'}
  </button>
</form>

          {/* Excel buttons */}
          <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
            <button
              onClick={handleDownloadTemplate}
              style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '8px 16px', borderRadius: 6, backgroundColor: '#0ea5e9', color: '#fff', border: 'none', cursor: 'pointer', fontWeight: 600, fontSize: 13 }}
            >
              <i className="fa-solid fa-download" /> Download Template
            </button>

            <label style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '8px 16px', borderRadius: 6, backgroundColor: uploading ? '#86efac' : '#22c55e', color: '#fff', cursor: uploading ? 'not-allowed' : 'pointer', fontWeight: 600, fontSize: 13 }}>
              <i className={`fa-solid ${uploading ? 'fa-circle-notch fa-spin' : 'fa-upload'}`} />
              {uploading ? 'Uploading…' : 'Upload Excel'}
              <input type="file" accept=".xlsx,.xls,.csv" onChange={handleUploadFile} disabled={uploading} style={{ display: 'none' }} />
            </label>
          </div>
        </div>

        {/* Table */}
          <div
  style={{
    flex: 1,
    overflow: 'auto',
    padding: '24px',
    background: '#f8fafc'
  }}
>
  <div
    style={{
      backgroundColor: '#fff',
      borderRadius: 12,
      border: '1px solid #e2e8f0',
      overflow: 'hidden',
      boxShadow: '0 2px 8px #0001',
      marginBottom: 30
    }}
  >
          <div style={{ overflowX: 'auto' }}>
            <table className='tablcss' style={{ width: '100%', borderCollapse: 'collapse', fontSize: 14 }}>
              <thead>
                <tr style={{ backgroundColor: '#f8fafc', borderBottom: '2px solid #e2e8f0' }}>
                  <th style={{ padding: '12px 16px', textAlign: 'left', fontWeight: 600, color: '#334155', width: 40 }}>#</th>
                  <th style={{ padding: '12px 16px', textAlign: 'left', fontWeight: 600, color: '#334155' }}>Name</th>
                  <th style={{ padding: '12px 16px', textAlign: 'left', fontWeight: 600, color: '#334155' }}>Keywords</th>
                  <th style={{ padding: '12px 16px', textAlign: 'center', fontWeight: 600, color: '#334155', width: 160 }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr><td colSpan={4} style={{ padding: 32, textAlign: 'center', color: '#64748b' }}>
                    <i className="fa-solid fa-circle-notch fa-spin" style={{ marginRight: 8 }} />Loading…
                  </td></tr>
                ) : categories.length === 0 ? (
                  <tr><td colSpan={4} style={{ padding: 32, textAlign: 'center', color: '#64748b' }}>
                    No SEO categories yet. Add one above.
                  </td></tr>
                ) : categories.map((c, i) => (
                  <tr key={c.id} style={{ borderBottom: '1px solid #e2e8f0', backgroundColor: '#fff', transition: 'background 0.15s' }}
                    onMouseOver={e => e.currentTarget.style.backgroundColor = '#f8fafc'}
                    onMouseOut={e => e.currentTarget.style.backgroundColor = '#fff'}>
                    <td style={{ padding: '12px 16px', color: '#94a3b8' }}>{i + 1}</td>
                    <td style={{ padding: '12px 16px' }}>
                      {editId === c.id ? (
                        <input value={editForm.name} onChange={e => setEditForm(p => ({ ...p, name: e.target.value }))}
                          style={{ padding: '6px 10px', borderRadius: 6, border: '1px solid #cbd5e1', fontSize: 13, width: '100%' }} />
                      ) : <strong>{c.name}</strong>}
                    </td>
                    <td style={{ padding: '12px 16px', color: '#64748b' }}>
                      {editId === c.id ? (
                        <input value={editForm.keywords} onChange={e => setEditForm(p => ({ ...p, keywords: e.target.value }))}
                          placeholder="e.g. plumber, pipe repair"
                          style={{ padding: '6px 10px', borderRadius: 6, border: '1px solid #cbd5e1', fontSize: 13, width: '100%' }} />
                      ) : c.keywords || '—'}
                    </td>
                    <td style={{ padding: '12px 16px', textAlign: 'center' }}>
                      {editId === c.id ? (
                        <div style={{ display: 'flex', gap: 6, justifyContent: 'center' }}>
                          <button onClick={() => handleEdit(c.id)}
                            style={{ padding: '5px 14px', borderRadius: 6, backgroundColor: '#22c55e', color: '#fff', border: 'none', cursor: 'pointer', fontSize: 12, fontWeight: 600 }}>
                            Save
                          </button>
                          <button onClick={() => setEditId(null)}
                            style={{ padding: '5px 14px', borderRadius: 6, backgroundColor: '#94a3b8', color: '#fff', border: 'none', cursor: 'pointer', fontSize: 12, fontWeight: 600 }}>
                            Cancel
                          </button>
                        </div>
                      ) : (
                        <div style={{ display: 'flex', gap: 6, justifyContent: 'center' }}>
                          <button onClick={() => { setEditId(c.id); setEditForm({ name: c.name || '', keywords: c.keywords || '' }); }}
                            style={{ padding: '5px 14px', borderRadius: 6, backgroundColor: '#0ea5e9', color: '#fff', border: 'none', cursor: 'pointer', fontSize: 12, fontWeight: 600 }}>
                            <i className="fa-solid fa-pen" style={{ marginRight: 4 }} />Edit
                          </button>
                          <button onClick={() => handleDelete(c.id)} disabled={deleting === c.id}
                            style={{ padding: '5px 14px', borderRadius: 6, backgroundColor: deleting === c.id ? '#cbd5e1' : '#ef4444', color: '#fff', border: 'none', cursor: deleting === c.id ? 'not-allowed' : 'pointer', fontSize: 12, fontWeight: 600 }}>
                            <i className="fa-solid fa-trash" style={{ marginRight: 4 }} />
                            {deleting === c.id ? '…' : 'Delete'}
                          </button>
                        </div>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        </div>
</div>
      </div>
        {isMobile && <MobileBottomNav activeTab={activeTab} setActiveTab={setActiveTab} />}

    </div>
    
  );
}